import { useEffect, useRef } from 'react';

/**
 * useDidMountDebounceEffect
 * Działa jak useEffect z debounce, ale pomija pierwsze wywołanie (czyli jak didMountEffect).
 *
 * @param func funkcja do wykonania
 * @param deps zależności (array)
 * @param delay czas debounce w ms (domyślnie 1000ms)
 */

export default (
  func,
  deps,
  delay = 1000
) => {
  const didMount = useRef(false);
  const timeoutRef = useRef(null);

  useEffect(() => {
    if (didMount.current) {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }

      timeoutRef.current = setTimeout(() => {
        func();
      }, delay);
    } else {
      didMount.current = true;
    }

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, deps);
};
